// extracted by mini-css-extract-plugin
export default {"container":"FileDownloadButton_container__Rfe5e","text":"FileDownloadButton_text__2CDc5"};